<template lang="pug">
  div
    filter-table(
      layout="text"
      :rowSelectedCount="rowsSelected"
      @inputSearchFilter="inputSearchFilter")
    .credits-table.ods-mt-6
      ods-table(
        v-loading="loadingTable"
        style='width: 100%'
        :data='tableDataRendered'
        :default-sort = "{prop: 'code', order: 'descending'}"
        @selection-change="handleSelectionChange"
        )
        ods-table-column(type="selection" width="50" )
        ods-table-column(prop='fecsolicitud' label='Fecha de solicitud' sortable)
          template(slot-scope="scope")
            div {{ getDate(scope.row.fecsolicitud) }}
        ods-table-column(prop='nombre' label='Nombre' sortable width="300" )
        ods-table-column(prop='numdoc' label='NIF / NIE' sortable)
        ods-table-column(prop='impsolicitud' label='Importe solicitado' sortable)
          template(slot-scope="scope")
            div {{ scope.row.impsolicitud | toCurrencyCode(scope.row.clamon) }}
        ods-table-column(prop='desestsolicitud' label='Estado' sortable class-name="cell-tag")
          template(slot-scope="scope")
            ods-tag(:type="getType(scope.row.codestsolicitud)") {{ scope.row.desestsolicitud }}
        ods-table-column(prop='desestfirma' label='Estado firma')

      div.footer
        paginator(
          :isNextPage="indMasDatos"
          :currentPage="currentPage"
          @buttonPrevAction="getPrevPage"
          @buttonNextAction="getNextPage")
        //- ods-pagination.footer__page(
        //- :page-sizes = '[5, 10, 50, 100]',
        //- :page-size = itemsPerPage,
        //- layout='prev, pager, next',
        //- :total='totalData'
        //- @size-change='handleSizeChange',
        //- @current-change='handleCurrentChange'
        //- style="text-align: right; margin-top: 20px")

</template>

<script>
import FilterTable from '@/components/shared/FilterTable'
import Paginator from '@/components/shared/Paginator'
export default {
  name: 'RequestTable',

  components: {
    FilterTable,
    Paginator
  },

  props: {
    // data: {
    //   required: true
    // }
  },

  data () {
    return {
      defaultParams: {
        producto: this.$route.params.comercio.producto,
        subproducto: this.$route.params.comercio.subproducto,
        conprod: this.$route.params.comercio.conprod.toString(),
        codcom: this.$route.params.comercio.codcom
      },
      paginationParams: null,
      tableData: null,
      tableDataRendered: null,
      currentPage: null,
      indMasDatos: null,
      loadingTable: false,
      rowsSelected: null
      // tableData: this.data,
      // itemsPerPage: 10,
      // currentPageData: 1,
      // totalData: 0
    }
  },

  // watch: {
  //   data (newData, oldData) {
  //     this.tableData = newData
  //     this.totalData = newData.length
  //   }
  // },

  methods: {
    async getData (params) {
      this.loadingTable = true
      // Listado de Financiación - Solicitudes
      await this.$store.dispatch('getRequests', params)
        .then((res) => {
          this.loadingTable = false
          if (res.registros) {
            this.tableData = Array.isArray(res.registros) ? res.registros : [res.registros]
            this.tableDataRendered = this.tableData
          } else {
            this.tableData = null
            this.tableDataRendered = this.tableData
          }
          this.currentPage = res.pantPagina
          this.indMasDatos = res.indMasDatos
          this.paginationParams = {
            claveInicio: res.claveInicio,
            claveFin: res.claveFin
          }
        })
    },

    getInitialData () {
      const params = {
        ...this.defaultParams
      }
      this.getData(params)
    },

    getPrevPage () {
      const params = {
        ...this.defaultParams,
        ...this.paginationParams,
        retroceder: true
      }
      this.getData(params)
    },

    getNextPage () {
      const params = {
        ...this.defaultParams,
        ...this.paginationParams,
        avanzar: true
      }
      this.getData(params)
    },

    inputSearchFilter (text) {
      this.tableDataRendered = this.tableData.filter((res) => {
        return res.numdoc.toLowerCase().includes(text.toLowerCase()) ||
          res.nombre.toLowerCase().includes(text.toLowerCase()) ||
          res.desestsolicitud.toLowerCase().includes(text.toLowerCase()) ||
          res.impsolicitud.toString().replace('.', ',').toLowerCase().includes(text.toLowerCase())
      })
    },

    // paramsDateFilter (val) {
    //   const params = {
    //     ...this.defaultParams,
    //     ...val
    //   }
    //   this.getData(params)
    // },

    // resetDateFilter () {
    //   this.getInitialData()
    // },

    handleSelectionChange (val) {
      this.rowsSelected = val.length
    },

    // handleSizeChange (val) {
    //   this.itemsPerPage = val
    //   this.handlePagination()
    // },

    getDate (date) {
      // a futuro hay que ponerlo con el filtro preparado para las fechas, pero tienen que cambiar la respuesta del servicio
      const fech = new Date(date.valueDate)
      return fech.toLocaleDateString()
    },

    // handleCurrentChange (val) {
    //   this.currentPageData = val
    //   this.handlePagination()
    // },

    // handlePagination (arr) {
    //   if (Array.isArray(this.data)) {
    //     this.tableData = this.data.slice(
    //       (this.currentPageData - 1) * this.itemsPerPage,
    //       this.currentPageData * this.itemsPerPage)
    //   }
    // },

    getType (row) {
      return row === '01' ? 'success' : 'danger'
    }
  },

  mounted () {
    this.getInitialData()
    // if (Array.isArray(this.data)) this.totalData = this.data.length
    // this.handlePagination()
  }
}
</script>

<style lang="scss" scoped>
.notfound {
  margin-top: rem(28)
}

/deep/ .ods-table__row {
  cursor: pointer;
}

/deep/ .ods-table__expanded-cell {
  padding: rem(12) rem(24)!important;
  background: #F9F9FB;
}

/deep/ .ods-table__expanded-cell:hover {
  background-color: #F9F9FB!important;
}

/deep/ .ods-table__expanded-cell:hover td {
  border-bottom: 1px solid #d1d9de;
}

.tramos {
  .title {
    text-transform: uppercase;
  }

  .ods-table {
    background: #fff;
    margin: 12px 0;
  }

  /deep/ .ods-table thead th {
    padding: 0;
  }

  /deep/ .ods-table td, .ods-table th {
    padding: 4px 0;
  }

  /deep/ .ods-table__row--striped > td {
    background: #F0F0F0!important;
  }
}
</style>
